export function extractUndefinedValue<Parameter>(parameter: Parameter): Parameter extends undefined ? null : Parameter;
export function extractUndefinedValue<Parameter>(parameter: Parameter): Parameter | null {
  return parameter ?? null;
}
